import { ActivatedRouteSnapshot } from '@angular/router';

export const getLastChild = (snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot =>
  snapshot.firstChild === null ? snapshot : getLastChild(snapshot.firstChild);
